// 轴线
import store from "@/store";
import {
  addEntityToDrawing,
  getEntityData,
  calculateDistanceAndAngle,
  enableSnapCorrection,
  saveDatabaseStore,
  ptOnArc,
} from "@/rlMxModules/operate/operateApi";
import {
  rlTextData,
  rlCircleData,
  rlLineData,
  rlJointData,
  rlGridData,
  rlGridArcData,
} from "@/rlMxModules/rlDataClass/index";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import rlBaseData from "./rlBaseData";
// import mxcad from "mxcad";
import {
  McDbLine,
  McCmColor,
  McDbText,
  McGePoint3d,
  McDbCircle,
  McDbPolyline,
  McDbArc,
  MxCpp,
} from "mxcad";

import {
  calculateArcAngle,
  calculateArcPoint,
  toDegrees,
  calculateArcPointsAngle,
  calculateArcCenterByThreePoint,
  calculatePointPosition,
} from "@/rlMxModules/operate/GraphicDataCal.js";
import {
  getInputElement,
  createInputElement,
  setInputElementPosition,
  setCurrDataObj,
  getInptNum,
  setContainerShow,
} from "@/rlMxModules/operate/inputElement.js";
import oneMessage from "@/utils/oneMessage.js";

import {
  createInputOtherElement,
  getInputOtherElement,
  setFunctionType,
  setInputElementPositionOther,
  setContainerShowOther,
  setCurrDataObjOther,
} from "@/rlMxModules/operate/inputElementOther.js";
import {
  createInputOther2Element,
  getInputOther2Element,
  setFunctionType2,
  setInputElementPositionOther2,
  setContainerShowOther2,
  setCurrDataObjOther2,
} from "@/rlMxModules/operate/inputElementOther2.js";
import { MovePt } from "../operate/structural";
class rlAxisArcData extends rlBaseData {
  constructor() {
    super();

    this.points = []; // 顶点列表

    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点

    // this.m_center = null; // 圆心
    // this.m_radius = null; // 半径
    this.m_stArcPoint = null; // 圆弧起点
    this.m_edArcPoint = null; // 圆弧终点

    this.Name = ""; // 轴线名称
    this.IsMainAxis = -1; // 是否是主轴

    this._threeObj = null; // 三维图形对象
    // this.defaultColor = new THREE.Color(0xffffff); //默认颜色
    this.Color = null; // 构件颜色
    this.lineWidth = 0; // 线宽

    this.classTypeName = "rlAxis"; // 轴线

    this.m_gridIds = new Array(); // 轴线上的网格集合

    this.mcDbAxis = new McDbArc(); // 轴线
    this.mcDbId = null; // 轴线ID
    this.textDistanceId = null; // 轴线距离文本ID
    this.textAngleId = null; // 轴线角度文本ID

    this.m_axisLineStPt = null; //轴线命名绘制数据的起点
    this.m_axisLineEdPt = null; //轴线命名绘制数据的终点

    // 轴线命名数据
    this.m_stText = null;
    this.m_edText = null;

    // 轴线命名辅助直线
    this.m_stLineTmp = null;
    // this.m_stLineTmpId = null;

    // 轴线命名辅助直线
    this.m_edLineTmp = null;
    // this.m_edLineTmpId = null;

    this.m_stCircle = null;
    // this.m_stCircleId = null;

    this.m_edCircle = null;
    // this.m_edCircleId = null;

    // this.lineObjId = -1;
    this.m_TextObj = null;

    this.drawingType = 0; //绘制方式：1三点绘制，2半径+角度绘制
    this.isShow = "1"; //是否显示
  }

  initData(obj) {
    // 合理性校验
    if (!obj.m_stJoint || !obj.m_edJoint) {
      this.erase();
      return;
    }

    super.initData(obj);
    if (this.mcDbId) {
      this.mcDbAxis = this.mcDbId.getMcDbEntity();
    }
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;

    this.Name = obj.Name == "" || obj.Name == undefined ? "" : obj.Name;
    this.IsMainAxis = obj.IsMainAxis;
    this.mcDbAxis.center = new McGePoint3d(
      obj.m_stJoint.m_pt[0],
      obj.m_stJoint.m_pt[1],
      obj.m_stJoint.m_pt[2]
    );
    this.mcDbAxis.radius = new THREE.Vector3(...obj.m_edJoint.m_pt).distanceTo(
      new THREE.Vector3(...obj.m_stJoint.m_pt)
    );

    this.m_stArcPoint = obj.m_stArcPoint;
    this.m_edArcPoint = obj.m_edArcPoint;

    this.mcDbAxis.startAngle = calculateArcAngle(
      this.mcDbAxis.center,
      new THREE.Vector3(...obj.m_stArcPoint)
    );

    this.mcDbAxis.endAngle = calculateArcAngle(
      this.mcDbAxis.center,
      new THREE.Vector3(...obj.m_edArcPoint)
    );
    this.mcDbAxis.visible = false;

    // 将数据和图形绑定
    this.mcDbAxis.setxDataString("Guid", this.Guid);
    this.mcDbAxis.setxDataString("classTypeName", this.classTypeName);
    if (obj.isShow) {
      this.isShow = obj.isShow;
    }
  }

  draw() {
    // 节点数据绑定
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
    // this.drawTextTest();
  }

  // 克隆
  myClone() {
    const newObj = new rlAxisArcData();
    newObj.m_stJoint = this.m_stJoint.myClone();
    newObj.m_edJoint = this.m_edJoint.myClone();
    newObj.m_Axis = null;
    newObj.StdFlrGuid = this.StdFlrGuid;
    newObj.mcDbGrid = this.mcDbGrid;
    newObj.mcDbGrid.startPoint = new McGePoint3d(
      newObj.m_stJoint.m_pt[0],
      newObj.m_stJoint.m_pt[1],
      newObj.m_stJoint.m_pt[2]
    );
    newObj.mcDbGrid.endPoint = new McGePoint3d(
      newObj.m_edJoint.m_pt[0],
      newObj.m_edJoint.m_pt[1],
      newObj.m_edJoint.m_pt[2]
    );

    // newObj.mcDbGrid.addVertexAt(newObj.mcDbGrid.startPoint);
    // newObj.mcDbGrid.addVertexAt(newObj.mcDbGrid.endPoint);

    newObj.Color = this.Color;
    newObj.mcDbGrid.setxDataString("Guid", newObj.Guid);
    newObj.mcDbGrid.setxDataString("classTypeName", newObj.classTypeName);
    return newObj;
  }

  // 用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_stJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_stJoint,
    });
    this.m_edJoint = getEntityData({
      classTypeName: "rlJoint",
      Guid: obj.m_edJoint,
    });
    if (!this.m_stJoint || !this.m_edJoint) {
      //   this.erase();
      return;
    }

    this.Name = obj.Name == "" || obj.Name == undefined ? "" : obj.Name;
    this.IsMainAxis = obj.IsMainAxis;
    this.m_stArcPoint = obj.m_stArcPoint;
    this.m_edArcPoint = obj.m_edArcPoint;

    this.mcDbAxis.center = new McGePoint3d(
      this.m_stJoint.m_pt[0],
      this.m_stJoint.m_pt[1],
      this.m_stJoint.m_pt[2]
    );
    this.mcDbAxis.radius = new THREE.Vector3(...this.m_edJoint.m_pt).distanceTo(
      new THREE.Vector3(...this.m_stJoint.m_pt)
    );

    this.m_stArcPoint = obj.m_stArcPoint;
    this.m_edArcPoint = obj.m_edArcPoint;
    this.mcDbAxis.startAngle = calculateArcAngle(
      this.mcDbAxis.center,
      new THREE.Vector3(...obj.m_stArcPoint)
    );

    this.mcDbAxis.endAngle = calculateArcAngle(
      this.mcDbAxis.center,
      new THREE.Vector3(...obj.m_edArcPoint)
    );
    // 节点数据绑定
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // 将数据和图形绑定
    this.mcDbAxis.setxDataString("Guid", this.Guid);
    this.mcDbAxis.setxDataString("classTypeName", this.classTypeName);
  }

  drawTextTest() {
    return;
    this.m_TextObj = new rlTextData();
    let position = new THREE.Vector3().lerpVectors(
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
      0.5
    );
    position.x -= 120;
    position.y -= 120;
    this.m_TextObj.position = position;
    // new THREE.Vector3(...this.m_pt);
    this.m_TextObj.Text = this.Guid.slice(-5);
    this.m_TextObj.textType = "测试轴线";
    this.m_TextObj.draw(true);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }
  // 节点变化时轴线相应更新
  updateData(jointObj) {
    if (this.m_gridIds && this.m_gridIds.length > 0) {
      // 删除端点后，若轴线上还存在网格，轴线的端点改变
      // 将轴线上的点都提取出来，都点排序，取首尾两点
      const isChangeStart = this.m_stJoint == jointObj;

      const axisPt = isChangeStart
        ? new THREE.Vector3(...this.m_edJoint.m_pt)
        : new THREE.Vector3(...this.m_stJoint.m_pt);
      const sortJointData = {};
      for (let i = 0; i < this.m_gridIds.length; i++) {
        const gridId = this.m_gridIds[i];

        const objGrid = getEntityData({
          classTypeName: "rlGrid",
          Guid: gridId,
        });
        if (!objGrid) {
          delete this.m_gridIds[i];
        } else {
          const dist1 = new THREE.Vector3(...objGrid.m_stJoint.m_pt).distanceTo(
            axisPt
          );
          const dist2 = new THREE.Vector3(...objGrid.m_edJoint.m_pt).distanceTo(
            axisPt
          );
          if (dist1 > dist2) {
            sortJointData[dist1] = objGrid.m_stJoint;
          } else {
            sortJointData[dist2] = objGrid.m_edJoint;
          }
        }
      }

      if (sortJointData) {
        const lastKey = Object.keys(sortJointData).pop();
        if (isChangeStart) {
          this.m_stJoint = sortJointData[lastKey];
        } else {
          this.m_edJoint = sortJointData[lastKey];
        }
        if (this.m_stJoint.Guid == "" || this.m_edJoint.Guid == "") {
          console.log(
            "轴线关联节点为空------节点删除时关联轴线更新！！！！！！！！"
          );
        }
        this.updateThisObj(this);
      }
    } else {
      // 否则，删除轴线
      this.erase();
    }
  }

  // 数据修改更新
  updateThisObj(obj, isUpdateDisplay = true) {
    this.initData(obj);
    super.updateThisObj(obj);
    // 删除功能选择多个同时删除时需要及时处理关联关系
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds.push(this.Guid);
    //   }
    // }
    if (this.m_stJoint.Guid == "" || this.m_edJoint.Guid == "") {
      console.log(
        "轴线关联节点为空------updateThisObj？？？？？？？？？？？？"
      );
    }
    //轴线绘制数据更新
    this.updateAxisName(this.Name);
    this.updateAxisDrawData();

    //测试代码
    this.m_TextObj?.erase();
    this.drawTextTest();
  }

  saveEditRevokeData() {
    //解除轴线与节点的关联
    // this.m_stJoint.m_AxisIds = this.m_stJoint.m_AxisIds.filter(
    //   (item) => item != this.Guid
    // );
    // this.m_edJoint.m_AxisIds = this.m_edJoint.m_AxisIds.filter(
    //   (item) => item != this.Guid
    // );
    super.saveEditRevokeData();
  }

  // 删除
  erase() {
    //删除轴线上所有网格
    //撤销回退中不处理关联处理
    if (!store.state.globalData.isReDo) {
      for (const item of this.m_gridIds) {
        let objGrid = getEntityData({
          classTypeName: "rlGrid",
          Guid: item,
        });
        if (objGrid) {
          objGrid.erase();
        }
      }
    }

    // if (this.m_stJoint) {
    //   if (this.m_stJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_stJoint.m_AxisIds = this.m_stJoint.m_AxisIds.filter(
    //       (item) => item != this.Guid
    //     );
    //     //
    //   }
    //   //撤销回退中不处理关联处理
    //   if (!store.state.globalData.isReDo) {
    //     if (
    //       this.m_stJoint.m_AxisIds.length == 0 &&
    //       this.m_stJoint.m_gridIds.length == 0
    //     ) {
    //       this.m_stJoint.erase();
    //     }
    //   }
    // }

    // if (this.m_edJoint) {
    //   if (this.m_edJoint.m_AxisIds.includes(this.Guid)) {
    //     this.m_edJoint.m_AxisIds = this.m_edJoint.m_AxisIds.filter(
    //       (item) => item != this.Guid
    //     );
    //     //
    //   }
    //   //撤销回退中不处理关联处理
    //   if (!store.state.globalData.isReDo) {
    //     if (
    //       this.m_edJoint.m_AxisIds.length == 0 &&
    //       this.m_edJoint.m_gridIds.length == 0
    //     ) {
    //       this.m_edJoint.erase();
    //     }
    //   }
    // }

    this.m_stText?.erase();
    this.m_edText?.erase();
    this.m_stCircle?.erase();
    this.m_edCircle?.erase();
    this.m_stLineTmp?.erase();
    this.m_edLineTmp?.erase();
    // this.m_stLineTmpId && this.m_stLineTmpId?.getMcDbEntity().erase();
    // this.m_edLineTmpId && this.m_edLineTmpId?.getMcDbEntity().erase();
    // this.m_stCircleId && this.m_stCircleId?.getMcDbEntity().erase();
    // this.m_edCircleId && this.m_edCircleId?.getMcDbEntity().erase();

    store.commit("globalData/deleteGuidToRlAxisLineLoad", this.Guid);
    this.mcDbAxis?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    super.erase();
    this.m_TextObj?.erase();
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();

    if (this.m_stJoint && this.m_stJoint.Guid != "")
      data["Jt1Guid"] = this.m_stJoint.Guid;

    if (this.m_edJoint && this.m_edJoint.Guid != "")
      data["Jt2Guid"] = this.m_edJoint.Guid;
    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    data["IsShow"] = this.isShow;
    return data;
  }

  getDrawData() {
    const data = super.getDrawData();

    data["m_stJoint"] = this.m_stJoint.Guid;
    data["m_edJoint"] = this.m_edJoint.Guid;

    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    data["m_gridIds"] = this.m_gridIds;

    data["m_stArcPoint"] = this.m_stArcPoint;
    data["m_edArcPoint"] = this.m_edArcPoint;
    // data["m_stText"] = this.m_stText.objectId();
    // data["m_edText"] = this.m_edText.objectId();
    // data["m_stLineTmp"] = this.m_stLineTmp.objectId();
    // data["m_edLineTmp"] = this.m_edLineTmp.objectId();
    // data["m_stCircle"] = this.m_stCircle.objectId();
    // data["m_edCircle"] = this.m_edCircle.objectId();
    return data;
  }

  // 移动
  transformBy(_mat) {
    // this.points.forEach(item => item.add(_mat))
    // this.setNeedUpdateDisplay(true);
  }

  //圆弧轴线绘制--预览效果
  //1. 三点确定圆弧
  drawArcByPointsPreview(straightLineSimulate) {
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });

    return new Promise((resolve, reject) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.clearLastInputPoint();
      fixOrthogonal(false);

      let pointArcStart = null; // 圆弧起点
      let pointArcMid = null; // 圆弧中点
      let pointArcSecond = null; // 圆弧第二个点
      let arcHeight = null; // 拱高
      let textId = null; //显示的文字id
      const mxcadobj = MxCpp.getCurrentMxCAD(); // 获取当前的 MxCAD 实例
      // 添加一个新的 TrueType 字体样式
      mxcadobj.AddTureTypeTextStyle("SimSunStyle", "SimSun");
      // 设置当前绘制的文字样式为新添加的样式
      mxcadobj.drawTextStyle = "SimSunStyle";
      oneMessage.info("点击设置圆弧起点");

      getPoint.go((status) => {
        if (status === -1 || status !== 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标
          return resolve();
        }

        store.commit("drawModules/setDrawPlay", true);
        // 开启正交模式
        fixOrthogonal(true);

        let inputElementOther2 = getInputOther2Element();
        if (!inputElementOther2) {
          inputElementOther2 = createInputOther2Element(this);
        } else if (inputElementOther2.style.display == "none") {
          setCurrDataObjOther2(this);
        }
        setContainerShowOther2(true, true, "请确认圆弧终点：");
        setFunctionType2("drawArcByPointsPreview");

        let inputElementOther = getInputOtherElement();
        if (!inputElementOther) {
          inputElementOther = createInputOtherElement(this);
        } else if (inputElementOther.style.display == "none") {
          setCurrDataObjOther(this);
        }
        setContainerShowOther(true, true, "角度：");
        setFunctionType("drawArcByPointsPreview");
        // 当前鼠标位置
        let pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        store.commit("cadModules/setSnapPoint", {
          snapPoint: pt1,
          needCatchSnap: false,
        });
        //设置捕捉优化
        if (!pt1) {
          pt1 = getPoint.value();
          let snapPoint = enableSnapCorrection(pt1);
          pt1 = snapPoint ? snapPoint : pt1;
        }
        getPoint.setBasePt(pt1);
        pointArcStart = pt1;
        this.drawingType = 1;

        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          // 获取当前视区的显示范围
          const viewDocCoord =
            rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();

          // 开启正交模式并设置点
          fixOrthogonal(true);
          let vec = new THREE.Vector3()
            .subVectors(
              new McGePoint3d(currentPoint.x, currentPoint.y, 0),
              new McGePoint3d(pt1.x, pt1.y, 0)
            )
            .normalize();
          if (window.drawArcByPointsPreviewAngle) {
            //计算角度所在的点,pt1为起点,计算角度drawArcByPointsPreviewAngle的方向
            // 将角度转换为弧度
            const radians =
              window.drawArcByPointsPreviewAngle * (Math.PI / 180);
            vec = new THREE.Vector3(Math.cos(radians), Math.sin(radians), 0);
            vec.normalize();
            let tmpPt = MovePt(new McGePoint3d(pt1.x, pt1.y, 0), vec, 100000);
            let line = new McDbLine();
            line.startPoint = new McGePoint3d(pt1.x, pt1.y, 0);
            line.endPoint = tmpPt;
            let ptTmp = new McGePoint3d(currentPoint.x, currentPoint.y, 0);
            let newPt = line.getClosestPointTo(ptTmp).val;
            currentPoint.x = newPt.x;
            currentPoint.y = newPt.y;
          }
          if (window.drawArcByPointsPreviewLength) {
            let tmpPt = MovePt(
              new McGePoint3d(pt1.x, pt1.y, 0),
              vec,
              window.drawArcByPointsPreviewLength
            );
            currentPoint.x = tmpPt.x;
            currentPoint.y = tmpPt.y;
          }
          let snapPoint = enableSnapCorrection(currentPoint, pt1);
          currentPoint = snapPoint ? snapPoint : currentPoint;

          //计算长度和角度
          let distance = pointArcStart.distanceTo(currentPoint);
          let angle = Math.atan2(
            currentPoint.y - pointArcStart.y,
            currentPoint.x - pointArcStart.x
          );
          angle = ((angle * 180) / Math.PI + 360) % 360;

          // 修正角度在左右侧的显示
          // if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
          //   angle -= Math.PI;
          // }

          let midPoint = new THREE.Vector3().lerpVectors(
            pointArcStart,
            currentPoint,
            0.5
          );
          // 根据视区范围调整文本大小
          const viewWidth = Math.abs(viewDocCoord.pt3.x - viewDocCoord.pt1.x);
          const referenceSize = 1000;
          let textSize = 12 * (viewWidth / referenceSize);

          // 绘制角度文字
          // let textObj = textId ? textId.getMcDbEntity() : new McDbText();
          // textObj.height = textSize;
          // textObj.textString = `${angle.toFixed(2)}°,${distance.toFixed(0)}`;
          // textObj.position = textObj.alignmentPoint = new McGePoint3d(
          //   midPoint.x,
          //   midPoint.y,
          //   0
          // );
          // if (!textId) {
          //   textId = rlAppObj.mxcadObject.drawEntity(textObj);
          // }

          setInputElementPositionOther(
            angle.toFixed(2),
            pointArcStart.x,
            pointArcStart.y - 800
          );
          // 实时更新输入框位置
          setInputElementPositionOther2(
            distance.toFixed(2),
            pointArcStart.x,
            pointArcStart.y
          );
        });

        // 输入圆弧上第二个点
        getPoint.go((status) => {
          if (status !== 0 || status === -1) {
            if (textId) {
              textId.getMcDbEntity().erase();
            }
            window.canvas
              .getContext("2d")
              .clearRect(0, 0, canvas.width, canvas.height);
            return resolve();
          }

          let snapPoint = enableSnapCorrection(getPoint.value(), pt1);
          pointArcSecond = snapPoint ? snapPoint : getPoint.value();
          this.points = [pointArcStart, pointArcSecond];

          pointArcMid = new THREE.Vector3().lerpVectors(
            pointArcStart,
            pointArcSecond,
            0.5
          );

          getPoint.setBasePt(pointArcMid);
          if (textId) {
            textId.getMcDbEntity().erase();
          }

          let inputElement = getInputElement();
          if (!inputElement) {
            inputElement = createInputElement(this);
          } else if (inputElement.style.display == "none") {
            setCurrDataObj(this);
          }
          setContainerShowOther(false);
          setContainerShowOther2(false);
          inputElement.type = "text";
          setContainerShow(true, true, "请输入拱高");
          setInputElementPositionOther(0, pointArcStart.x, pointArcStart.y);
          let lastPoint = null;
          getPoint.setUserDraw((currentPoint, pWorldDraw) => {
            if (arcHeight) {
              getPoint.setBasePt(lastPoint);
              getPoint.abort();
              return resolve(this);
            }
            let snapPoint = enableSnapCorrection(currentPoint, pt1);
            currentPoint = snapPoint ? snapPoint : currentPoint;
            lastPoint = currentPoint;

            let center = calculateArcCenterByThreePoint(
              pointArcStart,
              currentPoint,
              pointArcSecond
            );

            if (center) {
              let vec = new THREE.Vector3(
                currentPoint.x - pointArcMid.x,
                currentPoint.y - pointArcMid.y,
                0
              ).normalize();
              center = new THREE.Vector3(center.x, center.y, 0);
              let pointPosition = false;
              if (vec.x < 0 || (Math.abs(vec.x) < 0.000001 && vec.y < 0)) {
                // center = new THREE.Vector3(calCenters[1].x, calCenters[1].y, 0);
                pointPosition = true;
              }

              // center = new THREE.Vector3(center.x, center.y, 0);
              //计算一个点在直线的左上方还是右下方

              // calculatePointPosition(
              //   pointArcStart,
              //   pointArcSecond,
              //   currentPoint
              // ) > 0;

              // 计算圆弧的左端点和右端点
              let ptArcLeft = pointPosition ? pointArcStart : pointArcSecond;
              let ptArcRight = pointPosition ? pointArcSecond : pointArcStart;
              if (this.mcDbId) {
                this.mcDbAxis = this.mcDbId.getMcDbEntity();
                this.mcDbAxis.center = new McGePoint3d(center.x, center.y, 0);
                this.mcDbAxis.radius = pointArcStart.distanceTo(center);
                this.mcDbAxis.startAngle = calculateArcAngle(center, ptArcLeft);
                this.mcDbAxis.endAngle = calculateArcAngle(center, ptArcRight);
              } else {
                this.mcDbAxis.center = new McGePoint3d(center.x, center.y, 0);
                this.mcDbAxis.radius = pointArcStart.distanceTo(center);
                this.mcDbAxis.startAngle = calculateArcAngle(center, ptArcLeft);
                this.mcDbAxis.endAngle = calculateArcAngle(center, ptArcRight);
                this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
              }

              // 计算拱高--起点和第二个点到圆弧最高点的距离
              // let radius = pointArcStart.distanceTo(center);
              // let distance = center.distanceTo(pointArcMid);
              let arcHeightTmp = pointArcMid.distanceTo(currentPoint);

              // if (arcHeightTmp > radius) {
              //   arcHeightTmp = distance + radius;
              // }

              if (pointPosition) arcHeightTmp = -arcHeightTmp;
              setInputElementPosition(
                arcHeightTmp.toFixed(2),
                pointArcMid.x,
                pointArcMid.y
              );
            }
          });

          getPoint.setInputToucheType(2);
          getPoint.go((status) => {
            window.canvas
              .getContext("2d")
              .clearRect(0, 0, canvas.width, canvas.height);

            return resolve(this);
          });

          //监听拱高输入
          const handleArcHeightInput = () => {
            const input = getInptNum();
            if (input && !isNaN(input)) {
              arcHeight = Number(input);
              getPoint.setBasePt(lastPoint);
              getPoint.abort();
              return resolve(this);
            }
          };
          inputElement.addEventListener("blur", handleArcHeightInput);
        });
      });

      store.commit("drawModules/setDrawPlay", false);
    });
  }

  drawArcByCenterRadiusPreview() {
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: true,
    });
    return new Promise((resolve, reject) => {
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      getPoint.clearLastInputPoint();
      fixOrthogonal(false);

      let pointCenter = null; //圆心
      let pointArcStart = null; //圆弧上第一点

      let startAngle = null; //起点角度
      let endAngle = null; //终点角度
      let textId = null; //文字id
      let textSize = 10;
      const mxcadobj = MxCpp.getCurrentMxCAD(); // 获取当前的 MxCAD 实例
      // 添加一个新的 TrueType 字体样式
      mxcadobj.AddTureTypeTextStyle("SimSunStyle", "SimSun");
      // 设置当前绘制的文字样式为新添加的样式
      mxcadobj.drawTextStyle = "SimSunStyle";
      oneMessage.info("请选择圆心");

      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1 || status !== 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          return resolve();
        }

        store.commit("drawModules/setDrawPlay", true);
        // 开启正交模式
        fixOrthogonal(true);

        let inputElementOther2 = getInputOther2Element();
        if (!inputElementOther2) {
          inputElementOther2 = createInputOther2Element(this);
        } else if (inputElementOther2.style.display == "none") {
          setCurrDataObjOther2(this);
        }
        setContainerShowOther2(true, true, "请确认圆弧终点：");
        setFunctionType2("drawArcByCenterRadiusPreview");

        let inputElementOther = getInputOtherElement();
        if (!inputElementOther) {
          inputElementOther = createInputOtherElement(this);
        } else if (inputElementOther.style.display == "none") {
          setCurrDataObjOther(this);
        }
        setContainerShowOther(true, true, "角度：");
        setFunctionType("drawArcByCenterRadiusPreview");

        // 当前鼠标位置
        let pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        store.commit("cadModules/setSnapPoint", {
          snapPoint: pt1,
          needCatchSnap: false,
        });
        // //设置捕捉优化
        if (!pt1) {
          pt1 = getPoint.value();
          let snapPoint = enableSnapCorrection(pt1);
          pt1 = snapPoint ? snapPoint : pt1;
        }
        getPoint.setBasePt(pt1);
        pointCenter = pt1;

        //输入圆弧上第一个点
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          // 获取当前视区的显示范围
          const viewDocCoord =
            rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();

          let vec = new THREE.Vector3()
            .subVectors(
              new McGePoint3d(currentPoint.x, currentPoint.y, 0),
              new McGePoint3d(pt1.x, pt1.y, 0)
            )
            .normalize();
          if (window.drawArcByCenterRadiusPreviewAngle) {
            //计算角度所在的点,pt1为起点,计算角度drawArcByCenterRadiusPreviewAngle的方向
            // 将角度转换为弧度
            const radians =
              window.drawArcByCenterRadiusPreviewAngle * (Math.PI / 180);
            vec = new THREE.Vector3(Math.cos(radians), Math.sin(radians), 0);
            vec.normalize();
            let tmpPt = MovePt(new McGePoint3d(pt1.x, pt1.y, 0), vec, 100000);
            let line = new McDbLine();
            line.startPoint = new McGePoint3d(pt1.x, pt1.y, 0);
            line.endPoint = tmpPt;
            let ptTmp = new McGePoint3d(currentPoint.x, currentPoint.y, 0);
            let newPt = line.getClosestPointTo(ptTmp).val;
            currentPoint.x = newPt.x;
            currentPoint.y = newPt.y;
          }
          if (window.drawArcByCenterRadiusPreviewLength) {
            let tmpPt = MovePt(
              new McGePoint3d(pt1.x, pt1.y, 0),
              vec,
              window.drawArcByCenterRadiusPreviewLength
            );
            currentPoint.x = tmpPt.x;
            currentPoint.y = tmpPt.y;
          }

          let snapPoint = enableSnapCorrection(currentPoint, pointCenter);
          currentPoint = snapPoint ? snapPoint : currentPoint;

          let angle = Math.atan2(
            currentPoint.y - pointCenter.y,
            currentPoint.x - pointCenter.x
          );
          angle = ((angle * 180) / Math.PI + 360) % 360;

          // 修正角度在左右侧的显示
          if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
            angle -= Math.PI;
          }
          let distance = pointCenter.distanceTo(currentPoint);

          // 根据视区范围调整文本大小
          const viewWidth = Math.abs(viewDocCoord.pt3.x - viewDocCoord.pt1.x);
          const referenceSize = 1000;
          textSize = 10 * (viewWidth / referenceSize);

          // 计算中点位置用于显示距离
          let midPoint = new THREE.Vector3().lerpVectors(
            pointCenter,
            currentPoint,
            0.5
          );

          // 绘制角度文字
          // let textObj = textId ? textId.getMcDbEntity() : new McDbText();
          // textObj.height = textSize;
          // textObj.textString = `${angle.toFixed(2)}°,${distance.toFixed(0)}`;
          // textObj.position = textObj.alignmentPoint = new McGePoint3d(
          //   midPoint.x,
          //   midPoint.y,
          //   0
          // );
          // if (!textId) {
          //   textId = rlAppObj.mxcadObject.drawEntity(textObj);
          // }
          setInputElementPositionOther(
            angle.toFixed(2),
            pointCenter.x,
            pointCenter.y - 800
          );
          // 实时更新输入框位置
          setInputElementPositionOther2(
            distance.toFixed(2),
            pointCenter.x,
            pointCenter.y
          );
        });
        getPoint.setInputToucheType(1);
        getPoint.go((status) => {
          if (status !== 0) {
            if (textId) {
              textId.getMcDbEntity().erase();
            }
            window.canvas
              .getContext("2d")
              .clearRect(0, 0, canvas.width, canvas.height);
            return resolve();
          }

          let snapPoint = enableSnapCorrection(getPoint.value(), pt1);
          pointArcStart = snapPoint ? snapPoint : getPoint.value();
          startAngle = calculateArcAngle(pointCenter, pointArcStart);
          this.points = [pointCenter, pointArcStart];
          getPoint.setBasePt(pointArcStart);

          if (textId) {
            textId.getMcDbEntity().erase();
          }

          let inputElement = getInputElement();
          if (!inputElement) {
            inputElement = createInputElement(this);
          } else if (inputElement.style.display == "none") {
            setCurrDataObj(this);
          }
          setContainerShowOther(false);
          setContainerShowOther2(false);
          inputElement.readOnly = true;
          this.drawingType = 2;
          setContainerShow(true, true, "请输入圆弧起点与圆弧终点之间的夹角");

          fixOrthogonal(false);
          let lastPoint = null;
          //输入圆弧上第二点
          getPoint.setUserDraw((currentPoint, pWorldDraw) => {
            if (endAngle) {
              getPoint.setBasePt(lastPoint);
              getPoint.abort();
              return resolve(this);
            }
            let snapPoint = enableSnapCorrection(currentPoint, pointCenter);
            currentPoint = snapPoint ? snapPoint : currentPoint;
            lastPoint = currentPoint;
            let angle = calculateArcAngle(pointCenter, currentPoint);

            if (this.mcDbId) {
              this.mcDbId.getMcDbEntity().endAngle = angle;
            } else {
              this.mcDbAxis.center = new McGePoint3d(pointCenter);
              this.mcDbAxis.radius = pointCenter.distanceTo(pointArcStart);
              this.mcDbAxis.startAngle = startAngle;
              this.mcDbAxis.endAngle = angle;
              this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
            }

            let showAngle = toDegrees(
              calculateArcPointsAngle(pointCenter, pointArcStart, currentPoint)
            );
            setInputElementPosition(
              showAngle.toFixed(2),
              pointArcStart.x,
              pointArcStart.y
            );
          });

          getPoint.setInputToucheType(2);
          getPoint.go((status) => {
            inputElement.readOnly = false;
            window.canvas
              .getContext("2d")
              .clearRect(0, 0, canvas.width, canvas.height);
            inputElement.removeEventListener("blur", handleEndAngleInput);
            return resolve(this);
          });

          //监听终点角度
          const handleEndAngleInput = () => {
            const input = getInptNum();
            if (input && !isNaN(input)) {
              endAngle = Number(input);
              getPoint.setBasePt(lastPoint);
              getPoint.abort();
              return resolve(this);
            }
          };
          inputElement.addEventListener("blur", handleEndAngleInput);
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }

  // drawArcByCenterRadiusPreview(straightLineSimulate) {
  //   store.commit("cadModules/setSnapPoint", {
  //     snapPoint: null,
  //     needCatchSnap: true,
  //   });

  //   return new Promise((resolve, reject) => {
  //     const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
  //     getPoint.clearLastInputPoint();
  //     fixOrthogonal(false);

  //     let pointCenter = null;
  //     let pointArcStart = null;
  //     let pointArcEnd = null;
  //     let radius = null;
  //     let startAngle = null;
  //     let endAngle = null;
  //     // let tempLineId = null;

  //     // Step 1: Get center point
  //     getPoint.go((status) => {
  //       if (status === -1 || status !== 0 || !straightLineSimulate) {
  //         window.canvas
  //           .getContext("2d")
  //           .clearRect(0, 0, canvas.width, canvas.height);
  //         return resolve();
  //       }

  //       store.commit("drawModules/setDrawPlay", true);
  //       fixOrthogonal(true);

  //       pointCenter =
  //         store.state.cadModules.snapPoint.snapPoint || getPoint.value();

  //       if (!pointCenter) {
  //         window.canvas
  //           .getContext("2d")
  //           .clearRect(0, 0, canvas.width, canvas.height);
  //         return resolve();
  //       }
  //       getPoint.setBasePt(pointCenter);

  //       // Step 2: Create input element for radius
  //       let inputElement = getInputElement() || createInputElement(this);
  //       setCurrDataObj(this);
  //       setContainerShow(true, true, "请输入半径长度，或点击圆弧上一点");
  //       setIsGetValueOnly(true);

  //       this.drawingType = 2;
  //       //绘制半径
  //       getPoint.setUserDraw((currentPoint, pWorldDraw) => {
  //         let snapPoint = enableSnapCorrection(currentPoint, pointCenter);
  //         currentPoint = snapPoint ? snapPoint : currentPoint;

  //         let angle = calculateArcAngle(pointCenter, currentPoint);

  //         const distance = pointCenter.distanceTo(currentPoint);
  //         if (radius) {
  //           setInputElementPosition(
  //             (angle * 180) / Math.PI.toFixed(2),
  //             pointCenter.x,
  //             pointCenter.y
  //           );
  //         } else {
  //           setInputElementPosition(
  //             distance.toFixed(2),
  //             pointCenter.x,
  //             pointCenter.y
  //           );
  //         }
  //       });

  //       getPoint.go((status) => {
  //         if (status !== 0) {
  //           window.canvas
  //             .getContext("2d")
  //             .clearRect(0, 0, canvas.width, canvas.height);
  //           return resolve();
  //         }
  //         inputElement.removeEventListener("blur", handleRadiusInput);
  //         inputElement.removeEventListener("blur", handleStartAngleInput);
  //         if (radius && startAngle) {
  //           // 取消绘制
  //           rlAppObj.rlMxDrawObject.abort();
  //         }

  //         let pointTmp =
  //           enableSnapCorrection(getPoint.value()) || getPoint.value();

  //         if (!pointTmp) {
  //           window.canvas
  //             .getContext("2d")
  //             .clearRect(0, 0, canvas.width, canvas.height);
  //           return resolve();
  //         }

  //         getPoint.setBasePt(pointTmp);
  //         if (!radius || !startAngle) {
  //           if (!radius) {
  //             pointArcStart = new THREE.Vector3(pointTmp.x, pointTmp.y, 0);
  //             radius = pointCenter.distanceTo(pointArcStart);
  //             startAngle = calculateArcAngle(pointCenter, pointArcStart);
  //           } else {
  //             startAngle = calculateArcAngle(pointCenter, pointTmp);
  //             pointArcStart = calculateArcPoint(
  //               pointCenter,
  //               startAngle,
  //               radius
  //             );
  //             pointArcStart = new THREE.Vector3(
  //               pointArcStart.x,
  //               pointArcStart.y,
  //               0
  //             );
  //           }

  //           getEndPoint();
  //           this.points = [pointCenter, pointArcStart];

  //           getPoint.setBasePt(pointArcStart);
  //         }
  //       });

  //       const handleRadiusInput = () => {
  //         const input = getInptNum();
  //         if (input && !isNaN(input)) {
  //           radius = Number(input);
  //           promptForAngle();
  //         } else {
  //           // If no radius input, get point on arc
  //           getPoint.go((status) => {
  //             if (status !== 0) {
  //               window.canvas
  //                 .getContext("2d")
  //                 .clearRect(0, 0, canvas.width, canvas.height);
  //               return resolve();
  //             }
  //             pointArcStart =
  //               store.state.cadModules.snapPoint.snapPoint || getPoint.value();

  //             radius = pointCenter.distanceTo(pointArcStart);
  //             startAngle = calculateArcAngle(pointCenter, pointArcStart);
  //             this.points = [pointCenter, pointArcStart];
  //             getEndPoint();
  //           });
  //         }
  //       };

  //       // Prompt for angle input
  //       const promptForAngle = () => {
  //         setContainerShow(true, true, "请输入起始角度（度）");
  //         setInputElementPosition(
  //           toDegrees(startAngle).toFixed(2),
  //           pointCenter.x,
  //           pointCenter.y
  //         );
  //         setIsGetValueOnly(true);
  //         inputElement.removeEventListener("blur", handleRadiusInput);
  //         inputElement.addEventListener("blur", handleStartAngleInput);
  //       };

  //       // Handle angle input
  //       const handleStartAngleInput = () => {
  //         const input = getInptNum();
  //         if (input && !isNaN(input)) {
  //           startAngle = (Number(input) * Math.PI) / 180;
  //           pointArcStart = new THREE.Vector3(
  //             pointCenter.x + radius * Math.cos(startAngle),
  //             pointCenter.y + radius * Math.sin(startAngle),
  //             pointCenter.z
  //           );
  //           getPoint.setBasePt(pointArcStart);
  //           this.points = [pointCenter, pointArcStart];
  //           getEndPoint();
  //         }
  //       };

  //       // Get final point to complete the arc
  //       const getEndPoint = () => {
  //         setContainerShow(true, true, "请输入终点角度");
  //         setIsGetValueOnly(false);

  //         getPoint.setUserDraw((currentPoint, pWorldDraw) => {
  //           let snapPoint = enableSnapCorrection(currentPoint, pointCenter);
  //           currentPoint = snapPoint ? snapPoint : currentPoint;

  //           let angle = calculateArcAngle(pointCenter, currentPoint);

  //           if (this.mcDbId) {
  //             this.mcDbId.getMcDbEntity().endAngle = angle;
  //           } else {
  //             this.mcDbAxis.center = new McGePoint3d(pointCenter);
  //             this.mcDbAxis.radius = radius;
  //             this.mcDbAxis.startAngle = startAngle;
  //             this.mcDbAxis.endAngle = angle;
  //             this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbAxis);
  //           }

  //           setInputElementPosition(
  //             toDegrees(
  //               calculateArcPointsAngle(
  //                 pointCenter,
  //                 pointArcStart,
  //                 currentPoint
  //               )
  //             ).toFixed(2),
  //             pointArcStart.x,
  //             pointArcStart.y
  //           );
  //         });

  //         getPoint.go((status) => {
  //           window.canvas
  //             .getContext("2d")
  //             .clearRect(0, 0, canvas.width, canvas.height);

  //           // tempLineId.getMcDbEntity().erase();

  //           inputElement.removeEventListener("blur", handleRadiusInput);
  //           inputElement.removeEventListener("blur", handleStartAngleInput);
  //           inputElement.removeEventListener("blur", handleEndAngleInput);
  //           resolve(this);
  //         });
  //       };

  //       //监听终点角度
  //       const handleEndAngleInput = () => {
  //         const input = getInptNum();
  //         if (input && !isNaN(input)) {
  //           endAngle = Number(input);
  //           this.points = [pointCenter, pointArcStart];
  //           return resolve(this);
  //         }
  //       };
  //       inputElement.addEventListener("blur", handleEndAngleInput);
  //       inputElement.addEventListener("blur", handleRadiusInput);
  //     });
  //     store.commit("drawModules/setDrawPlay", false);
  //   });
  // }

  // async copyAxisData(vecMove) {
  //   // 移动点位置
  //   const sPt = new THREE.Vector3(...this.m_stJoint.m_pt)
  //     .add(vecMove)
  //     .toArray();
  //   let newStJoint = new rlJointData();
  //   newStJoint.initData({ m_pt: sPt });

  //   const ePt = new THREE.Vector3(...this.m_edJoint.m_pt)
  //     .add(vecMove)
  //     .toArray();
  //   let newEdJoint = new rlJointData();
  //   newEdJoint.initData({ m_pt: ePt });

  //   // 返回已存在的节点对象
  //   const isEditSP = await addEntityToDrawing(newStJoint, false);
  //   const isEditEP = await addEntityToDrawing(newEdJoint, false);

  //   let stArcPoint = new THREE.Vector3(...this.m_stArcPoint)
  //     .add(vecMove)
  //     .toArray();
  //   let edArcPoint = new THREE.Vector3(...this.m_edArcPoint)
  //     .add(vecMove)
  //     .toArray();

  //   // 判断移动后的网格位置上是否存在轴线，若没有，新增轴线，内部已实现重复校验
  //   // let axisObj = new rlAxisArcData();
  //   // axisObj.initData({
  //   //   m_stJoint: isEditSP || newStJoint,
  //   //   m_edJoint: isEditEP || newEdJoint,
  //   //   m_stArcPoint: stArcPoint,
  //   //   m_edArcPoint: edArcPoint,
  //   //   IsMainAxis: -1,
  //   // });

  //   // await addEntityToDrawing(axisObj, false);
  //   // if (isExistAxis) axisObj = isExistAxis;

  //   debugger;
  //   let endJoint = new rlJointData();
  //   endJoint.initData({ m_pt: [edArcPoint.x, edArcPoint.y, edArcPoint.z] });
  //   let existEndJoint = await addEntityToDrawing(endJoint, false);
  //   if (existEndJoint) {
  //     endJoint = existEndJoint;
  //   }

  //   const objGrid = new rlGridArcData();
  //   objGrid.initData({
  //     m_stJoint: isEditEP || newEdJoint,
  //     m_edJoint: endJoint,
  //     m_centerJoint: isEditSP || newStJoint,
  //     centerPoint: (isEditSP || newStJoint).m_pt,
  //     m_Axis: null,
  //   });

  //   // 将网格对象添加到绘图中
  //   await addEntityToDrawing(objGrid, false);

  //   // if (this.m_gridIds.length > 0) {
  //   //   let originGridData = getEntityData({
  //   //     classTypeName: "rlGrid",
  //   //     Guid: this.m_gridIds[0],
  //   //   });
  //   //   if (originGridData) {
  //   //     let gridSt = new THREE.Vector3(...originGridData.m_stJoint.m_pt)
  //   //       .add(vecMove)
  //   //       .toArray();
  //   //     let gridEd = new THREE.Vector3(...originGridData.m_edJoint.m_pt)
  //   //       .add(vecMove)
  //   //       .toArray();

  //   //     let newStGridJoint = new rlJointData();
  //   //     newStGridJoint.initData({ m_pt: gridSt });

  //   //     let newEdGridJoint = new rlJointData();
  //   //     newEdGridJoint.initData({ m_pt: gridEd });

  //   //     // 返回已存在的节点对象
  //   //     const isEditSP = await addEntityToDrawing(newStGridJoint, false);
  //   //     const isEditEP = await addEntityToDrawing(newEdGridJoint, false);

  //   //     // 创建一个新的rlGridData对象，并初始化数据
  //   //     const objGrid = new rlGridArcData();
  //   //     objGrid.initData({
  //   //       m_stJoint: isEditSP || newStGridJoint,
  //   //       m_edJoint: isEditEP || newEdGridJoint,
  //   //       centerPoint: axisObj.m_stJoint.m_pt,
  //   //       m_Axis: axisObj,
  //   //     });

  //   //     // 将网格对象添加到绘图中
  //   //     await addEntityToDrawing(objGrid, false);
  //   //   }
  //   // }
  // }

  // 计算轴线命名数据
  calAxisNameData = () => {
    let isVisible = store.state.displayData.axisDisplay;
    if (this.isShow == "0") isVisible = false;
    // 判断是否已经加载过轴线命名数据
    if (!store.state.globalData.rlAxisLineLoad.includes(this.Guid)) {
      store.commit("globalData/addGuidToRlAxisLineLoad", this.Guid);

      this.m_axisLineStPt = new THREE.Vector3(...this.m_stArcPoint);
      this.m_axisLineEdPt = new THREE.Vector3(...this.m_edArcPoint);

      // 轴线命名的显示隐藏
      // this.mcDbId.getMcDbEntity().visible = isVisible;
      // 计算直线的方向
      const stPos = this.m_axisLineStPt;
      const edPos = this.m_axisLineEdPt;

      const vecDirSt = new THREE.Vector3().subVectors(
        new THREE.Vector3(...this.m_stJoint.m_pt),
        stPos
      );
      const stLineNormal = new THREE.Vector3().crossVectors(
        vecDirSt,
        new THREE.Vector3(0, 0, 1)
      );
      stLineNormal.normalize();

      // 绘制轴线命名辅助直线
      const stExternLinePos = new THREE.Vector3(
        stPos.x - stLineNormal.x * 1500,
        stPos.y - stLineNormal.y * 1500,
        stPos.z
      );
      this.m_stLineTmp = new rlLineData();
      this.m_stLineTmp.McDbLine.trueColor = new McCmColor(150, 5, 80);
      this.m_stLineTmp.stPt = new McGePoint3d(stPos.x, stPos.y, stPos.z);
      this.m_stLineTmp.edPt = new McGePoint3d(
        stExternLinePos.x,
        stExternLinePos.y,
        stExternLinePos.z
      );
      this.m_stLineTmp.draw(isVisible);

      const vecDirEd = new THREE.Vector3().subVectors(
        new THREE.Vector3(...this.m_stJoint.m_pt),
        edPos
      );
      const edLineNormal = new THREE.Vector3().crossVectors(
        vecDirEd,
        new THREE.Vector3(0, 0, 1)
      );
      edLineNormal.normalize();

      // 绘制轴线命名辅助直线
      const edExternLinePos = new THREE.Vector3(
        edPos.x + edLineNormal.x * 1500,
        edPos.y + edLineNormal.y * 1500,
        edPos.z
      );

      this.m_edLineTmp = new rlLineData();
      this.m_edLineTmp.McDbLine.trueColor = new McCmColor(150, 5, 80);
      this.m_edLineTmp.stPt = new McGePoint3d(edPos.x, edPos.y, edPos.z);
      this.m_edLineTmp.edPt = new McGePoint3d(
        edExternLinePos.x,
        edExternLinePos.y,
        edExternLinePos.z
      );
      this.m_edLineTmp.draw(isVisible);

      // 绘制两端包围文字的圆
      const stExternPos = new THREE.Vector3(
        stPos.x - stLineNormal.x * 2000,
        stPos.y - stLineNormal.y * 2000,
        stPos.z
      );
      const radius = 500;

      this.m_stCircle = new rlCircleData();
      this.m_stCircle.ptCenter = new THREE.Vector3(
        stExternPos.x,
        stExternPos.y,
        stExternPos.z
      );
      this.m_stCircle.Radius = radius;
      this.m_stCircle.draw(isVisible);
      rlAppObj.rlMxDrawObject.updateDisplay();

      const edExternPos = new THREE.Vector3(
        edPos.x + edLineNormal.x * 2000,
        edPos.y + edLineNormal.y * 2000,
        edPos.z
      );
      this.m_edCircle = new rlCircleData();
      this.m_edCircle.ptCenter = new THREE.Vector3(
        edExternPos.x,
        edExternPos.y,
        edExternPos.z
      );
      this.m_edCircle.Radius = radius;
      this.m_edCircle.draw(isVisible);

      // 绘制两端轴线名称
      this.m_stText = new rlTextData();
      this.m_stText.position = stExternPos;
      this.m_stText.Text = this.Name;
      this.m_stText.textType = "轴号";
      this.m_stText.draw(isVisible);
      this.m_stText.lineObjId = this.m_stText.mcDbId;

      this.m_edText = new rlTextData();
      this.m_edText.position = edExternPos;
      this.m_edText.Text = this.Name;
      this.m_edText.textType = "轴号";
      this.m_edText.draw(isVisible);
      this.m_edText.lineObjId = this.m_edText.mcDbId;
    } else {
      this.showAxisName(isVisible);
    }
  };

  updateAxisName(Text) {
    this.Name = String(Text);

    if (this.m_stText.mcDbId) {
      this.m_stText.Text = String(Text);
      this.m_stText.mcDbId.getMcDbEntity().textString = String(Text);
    }

    // this.m_stText.setNeedUpdateDisplay(true);
    if (this.m_edText.mcDbId) {
      this.m_edText.Text = String(Text);
      this.m_edText.mcDbId.getMcDbEntity().textString = String(Text);
    }

    // this.m_edText.setNeedUpdateDisplay(true);
  }

  //轴线长度修改后，更新轴线命名数据
  updateAxisDrawData(LineStPt = null, LineEdPt = null) {
    // if (LineStPt) this.m_axisLineStPt = LineStPt;
    // else if (!this.m_axisLineStPt) {
    //   this.m_axisLineStPt = new THREE.Vector3(
    //     this.m_stJoint.m_pt[0],
    //     this.m_stJoint.m_pt[1],
    //     this.m_stJoint.m_pt[2]
    //   );
    // }
    // if (LineEdPt) this.m_axisLineEdPt = LineEdPt;
    // else if (!this.m_axisLineEdPt) {
    //   this.m_axisLineEdPt = new THREE.Vector3(
    //     this.m_edJoint.m_pt[0],
    //     this.m_edJoint.m_pt[1],
    //     this.m_edJoint.m_pt[2]
    //   );
    // }
    // // 计算直线的方向
    // const stPos = this.m_axisLineStPt;
    // const edPos = this.m_axisLineEdPt;
    // const vecDirSt = new THREE.Vector3().subVectors(
    //   stPos,
    //   new THREE.Vector3(...this.m_stJoint.m_pt)
    // );
    // const stLineNormal = new THREE.Vector3().crossVectors(
    //   vecDirSt,
    //   new THREE.Vector3(0, 0, 1)
    // );
    // stLineNormal.normalize();
    // // 绘制轴线命名辅助直线
    // const stExternLinePos = new THREE.Vector3(
    //   stPos.x - stLineNormal.x * 1500,
    //   stPos.y - stLineNormal.y * 1500,
    //   stPos.z
    // );
    // if (this.m_stLineTmp.mcDbId) {
    //   this.m_stLineTmp.mcDbId.getMcDbEntity().startPoint = new McGePoint3d(
    //     this.m_stJoint.m_pt[0],
    //     this.m_stJoint.m_pt[1],
    //     this.m_stJoint.m_pt[2]
    //   );
    //   this.m_stLineTmp.mcDbId.getMcDbEntity().endPoint = new McGePoint3d(
    //     stExternLinePos.x,
    //     stExternLinePos.y,
    //     stExternLinePos.z
    //   );
    // }
    // // 绘制轴线命名辅助直线
    // const edExternLinePos = new THREE.Vector3(
    //   edPos.x + stLineNormal.x * 1500,
    //   edPos.y + stLineNormal.y * 1500,
    //   edPos.z
    // );
    // if (this.m_edLineTmp.mcDbId) {
    //   this.m_edLineTmp.mcDbId.getMcDbEntity().startPoint = new McGePoint3d(
    //     this.m_edJoint.m_pt[0],
    //     this.m_edJoint.m_pt[1],
    //     this.m_edJoint.m_pt[2]
    //   );
    //   this.m_edLineTmp.mcDbId.getMcDbEntity().endPoint = new McGePoint3d(
    //     edExternLinePos.x,
    //     edExternLinePos.y,
    //     edExternLinePos.z
    //   );
    // }
    // // 绘制两端包围文字的圆
    // const stExternPos = new THREE.Vector3(
    //   stPos.x - stLineNormal.x * 2000,
    //   stPos.y - stLineNormal.y * 2000,
    //   stPos.z
    // );
    // if (this.m_stCircle.mcDbId) {
    //   this.m_stCircle.mcDbId.getMcDbEntity().center = new McGePoint3d(
    //     stExternPos.x,
    //     stExternPos.y,
    //     stExternPos.z
    //   );
    //   // this.m_stCircle.mcDbId.getMcDbEntity().radius = radius;
    // }
    // const edExternPos = new THREE.Vector3(
    //   edPos.x + edLineNormal.x * 2000,
    //   edPos.y + edLineNormal.y * 2000,
    //   edPos.z
    // );
    // if (this.m_edCircle.mcDbId) {
    //   this.m_edCircle.mcDbId.getMcDbEntity().center = new McGePoint3d(
    //     edExternPos.x,
    //     edExternPos.y,
    //     edExternPos.z
    //   );
    //   // this.m_edCircle.mcDbId.getMcDbEntity().radius = radius;
    // }
    // // 绘制两端轴线名称
    // if (this.m_stText.mcDbId) {
    //   let position = new McGePoint3d(
    //     stExternPos.x,
    //     stExternPos.y,
    //     stExternPos.z
    //   );
    //   this.m_stText.position = position;
    //   this.m_stText.mcDbId.getMcDbEntity().alignmentPoint = position;
    // }
    // if (this.m_edText.mcDbId) {
    //   let position = new McGePoint3d(
    //     edExternPos.x,
    //     edExternPos.y,
    //     edExternPos.z
    //   );
    //   this.m_edText.position = position;
    //   this.m_edText.mcDbId.getMcDbEntity().alignmentPoint = position;
    // }
  }
  // 轴线命名的显示隐藏
  showAxisName(isShow) {
    if (
      this.mcDbId &&
      this.m_stText &&
      this.m_edText &&
      this.m_stLineTmp &&
      this.m_edLineTmp &&
      this.m_stCircle &&
      this.m_edCircle
    ) {
      let showAxis = isShow;
      if (this.isShow == "0") {
        showAxis = false;
      }
      // this.mcDbId.getMcDbEntity().visible = isShow;
      if (this.m_stText.mcDbId) {
        this.m_stText.mcDbId.getMcDbEntity().visible = showAxis;
        // this.m_stText.setNeedUpdateDisplay(true);
      }

      if (this.m_edText.mcDbId) {
        this.m_edText.mcDbId.getMcDbEntity().visible = showAxis;
        // this.m_edText.setNeedUpdateDisplay(true);
      }

      if (this.m_stLineTmp.mcDbId) {
        this.m_stLineTmp.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_stLineTmp.setNeedUpdateDisplay(true);
      }

      if (this.m_edLineTmp.mcDbId) {
        this.m_edLineTmp.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_edLineTmp.setNeedUpdateDisplay(true);
      }

      if (this.m_stCircle.mcDbId) {
        this.m_stCircle.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_stCircle.setNeedUpdateDisplay(true);
      }

      if (this.m_edCircle.mcDbId) {
        this.m_edCircle.mcDbId.getMcDbEntity().visible = showAxis;
        //  this.m_edCircle.setNeedUpdateDisplay(true);
      }
      rlAppObj.rlMxDrawObject.updateDisplay();
    }
  }
}

export { rlAxisArcData };
